export class NavbarSkin{
  navbarhtml(){
    return  `
      <nav class="navbar">
        <a class="navbar-brand" data-path="/">
          <img src="/assets/vetra.png" alt="Vetra">
        </a>

        <div class="navbar-menu">
          <ul class="navbar-links">
              <!-- <li><a href="/" >Home</a></li>
                <li class="superadmin-only"><a href="/users" data-path="/users">Users</a></li>
                <li class="superadmin-only"><a href="/logs" data-path="/logs">Logs</a></li> -->
          </ul>

          <div class="navbar-user">
              <button class="dropdown-toggle" id="userDropdown">User ▼</button>
              <ul class="dropdown-menu">
                <li><button id="logout">Logout</button></li>
              </ul>

              <span class="flag-icon">🇳🇬</span>

              <button id="themeToggle">
                <span class="iconify" data-icon="mdi:theme-light-dark" data-inline="false"></span>
              </button>
          </div>

          <button class="hamburger" id="hamburgerBtn">☰</button>
        </div>
      </nav>
    `;
  }
}
